<template>
  <div ref="root">
    <container width="100%">
      <grid horizontal="between"
            vertical="stretch"
            :rwd="{compact: 'stack'}"
            :direction="reverse"
            :key="reverse"
      >
        <grid-item :rwd="{compact: '1/1'}" size="1/2" v-if="image" class="poi-image">
          <img :src="image"/>
        </grid-item>
        <grid-item size="1/2" :rwd="{compact: '1/1'}">
          <div class="poi-title">{{title}}</div>
          <div class="poi-subtitle" v-if="distance && visitLength">
            {{distance}} away, expect to spend {{visitLength}} here
          </div>
          <div class="poi-content">
            <slot/>
          </div>
        </grid-item>
      </grid>
    </container>
  </div>
</template>

<script>
  export default {
    name: 'PlaceOfInterest',
    props: {
      image: {
        type: String,
        required: false,
      },
      title: {
        type: String,
        required: true,
      },
      distance: String,
      visitLength: String,
    },
    data() {
      return { reverse: '' }
    },
    mounted() {
      const cssVar = getComputedStyle(this.$refs.root)
        .getPropertyValue('--poi-reverse')
      const canonicalVar = cssVar.trim()
        .toLowerCase()
      this.reverse = (canonicalVar === 'true') ? 'reverse' : ''
    },
  }
</script>

<style lang="scss" scoped>
  .poi-title {
    font-size: 2rem;
    text-align: left;
  }

  .poi-subtitle {
    font-size: 0.9rem;
    color: var(--text-color-unpop);
    text-align: left;
  }

  .poi-content {
    text-align: justify;
  }

  .poi-image img {
    object-fit: cover;
    width: 100%;
    margin-bottom: 1rem;
  }


</style>
